import { createIcon } from '@chakra-ui/react';
import { jsx as _jsx } from "react/jsx-runtime";
export var OtherEventIcon = createIcon({
  displayName: 'OtherEventIcon',
  viewBox: '0 0 32 32',
  path: [/*#__PURE__*/_jsx("path", {
    d: "M28.0013 6.66699H4.0013C3.64768 6.66699 3.30854 6.80747 3.05849 7.05752C2.80844 7.30757 2.66797 7.6467 2.66797 8.00033V24.0003C2.66797 24.3539 2.80844 24.6931 3.05849 24.9431C3.30854 25.1932 3.64768 25.3337 4.0013 25.3337H28.0013C28.3549 25.3337 28.6941 25.1932 28.9441 24.9431C29.1942 24.6931 29.3346 24.3539 29.3346 24.0003V8.00033C29.3346 7.6467 29.1942 7.30757 28.9441 7.05752C28.6941 6.80747 28.3549 6.66699 28.0013 6.66699ZM28.0013 24.0003H4.0013V8.00033H28.0013V24.0003Z",
    fill: "currentColor"
  }), /*#__PURE__*/_jsx("path", {
    d: "M16.0013 18.0003C17.1059 18.0003 18.0013 17.1049 18.0013 16.0003C18.0013 14.8958 17.1059 14.0003 16.0013 14.0003C14.8967 14.0003 14.0013 14.8958 14.0013 16.0003C14.0013 17.1049 14.8967 18.0003 16.0013 18.0003Z",
    fill: "currentColor"
  }), /*#__PURE__*/_jsx("path", {
    d: "M22.668 18.0003C23.7725 18.0003 24.668 17.1049 24.668 16.0003C24.668 14.8958 23.7725 14.0003 22.668 14.0003C21.5634 14.0003 20.668 14.8958 20.668 16.0003C20.668 17.1049 21.5634 18.0003 22.668 18.0003Z",
    fill: "currentColor"
  }), /*#__PURE__*/_jsx("path", {
    d: "M9.33464 18.0003C10.4392 18.0003 11.3346 17.1049 11.3346 16.0003C11.3346 14.8958 10.4392 14.0003 9.33464 14.0003C8.23007 14.0003 7.33464 14.8958 7.33464 16.0003C7.33464 17.1049 8.23007 18.0003 9.33464 18.0003Z",
    fill: "currentColor"
  })]
});
//# sourceMappingURL=OtherEventIcon.js.map